import { merge, isNil } from 'lodash';

const defaultComponentRefContext = {
  defaultKind: "Component",
  defaultNamespace: "default"
};
const defaultGroupRefContext = {
  defaultKind: "Group",
  defaultNamespace: "default"
};
const defaultSystemRefContext = {
  defaultKind: "System",
  defaultNamespace: "default"
};
const applyCustomMappings = (entity, customMappings) => {
  return customMappings.reduce(
    (modifiedEntity, customMapping) => {
      const partialEntity = {
        spec: customMapping(entity)
      };
      merge(modifiedEntity, partialEntity);
      return modifiedEntity;
    },
    entity
  );
};
const entityComponentRef = (entitiesByTag, tag) => {
  const entity = entitiesByTag[tag];
  if (isNil(entity)) {
    return tag;
  }
  return isNil(entity.definition) || isNil(entity.definition.name) ? entity.codeTag : `${entity.definition.kind}:${entity.definition.namespace}/${entity.definition.name}`;
};

export { applyCustomMappings, defaultComponentRefContext, defaultGroupRefContext, defaultSystemRefContext, entityComponentRef };
//# sourceMappingURL=ComponentUtils.esm.js.map
